export enum ConfigTypes {
    Country = 'country',
    Company = 'company',
    OrgUnit = 'orgunit'
}
